import ImprefectionReportImageGallery from '@/components/shared/Imprefections-images-gallery/ImprefectionsGallery.component';
import Typography from '@/components/shared/typography/typography.component';
import {
    ImperfectionReportItem,
    ImperfectionReportSectionGrouped,
    highlightsType,
} from '@/types';
import { TFunction } from 'i18next';
import Image from 'next/image';
import { GrouppedGreenStarts, HighlightsIcon } from 'public/Images';
import { FC, Fragment, useState } from 'react';

interface NotesSectionContentProps {
    imperfectionDataGroupped: ImperfectionReportSectionGrouped;
    highlights: highlightsType | null;
    IS_RTL: boolean;
    t: TFunction<'translation', undefined>;
}

const NotesItemContent = ({
    item,
    tags,
    remarkNotes,
}: {
    item: ImperfectionReportItem;
    tags: string | null;
    remarkNotes: string[] | null;
    IS_RTL: boolean;
}) => {
    const [disableGallery, setDisableGallery] = useState(true);
    const getDisableGalleryState = (disableGallery: boolean) => {
        setDisableGallery(disableGallery);
    };
    return (
        <div className={`${disableGallery ? 'disable-gallery' : ''}`}>
            <div
                className="flex disable-gallery:flex-row flex-col md:flex-row            
                w-full justify-between items-center relative md:gap-0 gap-2"
            >
                <div className="w-full disable-gallery:order-[0] disable-gallery:self-center order-2 md:order-[0] self-start md:self-center">
                    {remarkNotes ? (
                        <>
                            {remarkNotes?.map(note => {
                                return (
                                    <Typography
                                        key={`${note} remark-note`}
                                        variant="caption"
                                        className="!text-gray-600 en:disable-gallery:ml-[38px] ar:mr-[38px]"
                                    >
                                        <li>{note}</li>
                                    </Typography>
                                );
                            })}
                        </>
                    ) : (
                        <Typography
                            variant="caption"
                            className={`!text-gray-600 md:en:ml-[35px] md:ar:mr-[35px] en:disable-gallery:ml-[35px] ar:disable-gallery:mr-[35px] transition-[width] duration-500 ${
                                item.images &&
                                'disable-gallery:w-[190px] disable-gallery:md:w-[90%] md:w-[calc(100%-40px)] disable-gallery:md:w-full]'
                            } `}
                        >
                            <span className="ar:hidden"> {item.name_en}</span>
                            <span className="en:hidden"> {item.name_ar}</span>
                            {tags && ' - '}
                            {tags}
                        </Typography>
                    )}
                </div>
                {item.images && (
                    <ImprefectionReportImageGallery
                        getDisableGalleryState={getDisableGalleryState}
                        images={item.images}
                    />
                )}
            </div>
        </div>
    );
};

const NotesSectionContent: FC<NotesSectionContentProps> = ({
    highlights,
    imperfectionDataGroupped,
    IS_RTL,
    t,
}) => {
    return (
        <div>
            {highlights &&
                (IS_RTL ? (
                    <div className="flex flex-col gap-4 mb-4">
                        {highlights.ar?.map(item => {
                            return (
                                <div
                                    key={`${item} highlight-note`}
                                    className="w-full flex items-center justify-between bg-white border border-gray-200 rounded-xl py-4 px-3"
                                >
                                    <div className="w-[calc(100%-70px)] flex items-center gap-2.5">
                                        <Image
                                            src={HighlightsIcon}
                                            alt="stars"
                                            className="self-start"
                                        />
                                        <Typography
                                            variant="body2SemiBold"
                                            className="!text-gray-700 w-[calc(100%-70px)]"
                                        >
                                            {item}
                                        </Typography>
                                    </div>
                                    <div className="flex items-center gap-1 justify-center rounded-[100px] bg-blue-50 px-2.5 py-1 w-16">
                                        <Image
                                            src={GrouppedGreenStarts}
                                            alt="stars"
                                        />
                                        <Typography
                                            variant="captionMedium"
                                            className="!text-primary-600"
                                        >
                                            {t('New')}
                                        </Typography>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="flex flex-col gap-4 mb-4">
                        {highlights.en?.map(item => {
                            return (
                                <div
                                    key={`${item} highlight-note`}
                                    className="w-full flex items-center justify-between bg-white border border-gray-200 rounded-xl py-4 px-3"
                                >
                                    <div className="w-[calc(100%-70px)] flex items-center gap-2.5">
                                        <Image
                                            src={HighlightsIcon}
                                            alt="stars"
                                            className="self-start"
                                        />
                                        <Typography
                                            variant="body2SemiBold"
                                            className="!text-gray-700 w-[calc(100%-70px)]"
                                        >
                                            {item}
                                        </Typography>
                                    </div>
                                    <div className="flex items-center gap-1 justify-center rounded-[100px] bg-blue-50 px-2.5 py-1 w-16">
                                        <Image
                                            src={GrouppedGreenStarts}
                                            alt="stars"
                                        />
                                        <Typography
                                            variant="captionMedium"
                                            className="!text-primary-600"
                                        >
                                            New
                                        </Typography>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}

            <div className="pb-20 md:pb-2">
                {imperfectionDataGroupped?.faulty?.map((section, index) => {
                    return (
                        <div key={`${section.name_en} section-notes`}>
                            {index !== 0 && (
                                <div className="w-full h-1 my-1.5"></div>
                            )}
                            <div className="w-full flex flex-col gap-4 bg-white border border-gray-200 rounded-xl ">
                                <div className="w-full py-4 px-3 flex items-start">
                                    <div className="flex flex-col gap-1 w-full">
                                        {section.items.length > 1 && (
                                            <div className="flex items-center">
                                                <div className="w-6 h-6 self-start en:mr-2.5 ar:ml-2.5">
                                                    {section.section_faulty_icon && (
                                                        <img
                                                            src={
                                                                section.section_faulty_icon
                                                            }
                                                            alt="unfaulty-icon"
                                                            className="object-fill h-full w-full"
                                                        />
                                                    )}
                                                </div>
                                                <div className="w-[calc(100%-40px)]">
                                                    <Typography
                                                        variant="body2SemiBold"
                                                        className="!text-gray-700 ar:hidden"
                                                    >
                                                        {section.name_en}
                                                    </Typography>
                                                    <Typography
                                                        variant="body2SemiBold"
                                                        className="!text-gray-700 en:hidden "
                                                    >
                                                        {section.name_ar}
                                                    </Typography>
                                                </div>
                                            </div>
                                        )}

                                        {section?.items?.map((item, index) => {
                                            let remarkNotes: string[] | null =
                                                null;
                                            if (
                                                item.item_type === 'TEXT_ONLY'
                                            ) {
                                                remarkNotes = IS_RTL
                                                    ? item.comment_ar.split('/')
                                                    : item.comment_en.split(
                                                          '/'
                                                      );
                                            }

                                            const tags = item?.tags
                                                ?.map(item =>
                                                    IS_RTL
                                                        ? item.tag_ar
                                                        : item.tag_en
                                                )
                                                .join(' - ');

                                            return (
                                                <Fragment
                                                    key={`${item.imperfection_item_id} id-notes`}
                                                >
                                                    <div className="flex w-full justify-between items-center min-h-11 md:gap-2">
                                                        <div className="flex flex-col w-full md:gap-1 gap-2">
                                                            {section.items
                                                                .length <= 1 &&
                                                                index === 0 && (
                                                                    <div className="flex items-center">
                                                                        <div className="w-6 h-6 self-start en:mr-2.5 ar:ml-2.5">
                                                                            {section.section_faulty_icon && (
                                                                                <img
                                                                                    src={
                                                                                        section.section_faulty_icon
                                                                                    }
                                                                                    alt="unfaulty-icon"
                                                                                    className="object-fill h-full w-full"
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="w-[calc(100%-40px)]">
                                                                            <Typography
                                                                                variant="body2SemiBold"
                                                                                className="!text-gray-700 ar:hidden"
                                                                            >
                                                                                {
                                                                                    section.name_en
                                                                                }
                                                                            </Typography>
                                                                            <Typography
                                                                                variant="body2SemiBold"
                                                                                className="!text-gray-700 en:hidden"
                                                                            >
                                                                                {
                                                                                    section.name_ar
                                                                                }
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            <NotesItemContent
                                                                item={item}
                                                                remarkNotes={
                                                                    remarkNotes
                                                                }
                                                                tags={tags}
                                                                IS_RTL={IS_RTL}
                                                            />
                                                        </div>
                                                    </div>
                                                    {index <
                                                        section.items.length -
                                                            1 && (
                                                        <div className="w-full border-b border-gray-200 my-3"></div>
                                                    )}
                                                </Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default NotesSectionContent;
